import { Component, EventEmitter, Output, inject } from '@angular/core';
import { AuthenticationService } from '@core/authentication/services';
import { NavMenuItem } from '../models/nav-menu-item.model';
import { DashboardLayoutService } from '../dashboard-layout.service';
import { CommunityResourcesDialogDirective } from '@shared/directives/community-resources-dialog.directive';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { LibComponentsModule, SecurityModule } from '@mynexus/mynexus-ui-lib';
import { SpecialtyProgramPermissionsEnum } from '@core/constants/permissions.enum';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-dashboard-layout-header',
  templateUrl: './dashboard-layout-header.component.html',
  styleUrls: ['./dashboard-layout-header.component.scss'],
  imports: [
    RouterModule,
    CommonModule,
    ButtonModule,
    LibComponentsModule,
    CommunityResourcesDialogDirective,
    SecurityModule
  ],
  providers: [AuthenticationService]
})
export class DashboardLayoutHeaderComponent {
  private readonly authenticationService = inject(AuthenticationService);
  private readonly dashboardLayoutService = inject(DashboardLayoutService);

  userName = this.authenticationService.userName;
  sidebarVisible = false;
  menuIcon = 'pi pi-bars';

  @Output() toggleSidebar: EventEmitter<void> = new EventEmitter<void>();

  readonly specialtyProgramPermissions = SpecialtyProgramPermissionsEnum;

  get navMenuItems(): NavMenuItem[] {
    return this.dashboardLayoutService.navMenuItems;
  }

  onToggleSidebar() {
    this.sidebarVisible = !this.sidebarVisible;
    this.toggleSidebar.emit();
    this.changeMenuIcon();
  }

  changeMenuIcon(): void {
    this.menuIcon = this.sidebarVisible ? 'pi pi-chevron-left' : 'pi pi-chevron-right';
  }

  redirectToHomePage(): void {
    this.dashboardLayoutService.redirectToHomePage();
  }

  logout(): void {
    this.authenticationService.logout();
  }
}
